import { useEffect, useRef } from 'react';

/**
 * The keys that came after the first render: those rows enter once (design s1 "rows enter one by
 * one"). The first render animates nothing, so a page load does not move.
 */
export function useNewRows(keys: string[]): ReadonlySet<string> {
  const seen = useRef<Set<string> | null>(null);
  const fresh =
    seen.current === null ? new Set<string>() : new Set(keys.filter((key) => seen.current?.has(key) !== true));
  useEffect(() => {
    seen.current = new Set([...(seen.current ?? []), ...keys]);
  });
  return fresh;
}
